module.exports = __webpack_public_path__ + "img/icon_13.f622ddc0.png";